// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-skins-connectionDegree-badge-bbe8080b"};